interface CatalogRequestStateProps {
  error?: string;
  onRetry?: () => void;
}

export function CatalogRequestState({ error, onRetry }: CatalogRequestStateProps) {
  if (error) {
    return <div className="catalog-feedback catalog-feedback_error" role="alert"><strong>{error}</strong><p>Повторите загрузку или вернитесь к списку.</p>{onRetry ? <button className="catalog-button" onClick={onRetry} type="button">Повторить загрузку</button> : null}</div>;
  }
  return <div className="catalog-loading" role="status" aria-label="Загрузка карточки"><span /><span /><span /><p>Загружаем карточку…</p></div>;
}
